import { LoginRouter } from 'pages/LoginRouter'
import React from 'react'
import { Col, Container, Navbar, Row } from 'react-bootstrap'
import { A } from 'hookrouter'
import { Logo } from 'components/Logo'

export const UnauthorizedView = () => (
  <div className="content">
    <Navbar expand="lg">
      <Navbar.Brand as={A} href="/">
        <Logo />
      </Navbar.Brand>
    </Navbar>
    <Container fluid>
      <Row>
        <Col>
          <LoginRouter />
        </Col>
      </Row>
    </Container>
  </div>
)
